export const LOADER_DATA_TEST_ID = 'loader'
export const CREATIONS_DATA_TEST_ID = 'creations'
export const SMART_WEARABLE_FILTER = 'smart-wearable-filter'
export const CREATION_ITEM_DATA_TEST_ID = 'creation-item'
export const CREATIONS_CLEAR_FILTERS_DATA_TEST_ID = 'creations-clear-filters'
export const ITEMS_PER_PAGE = 24
